import { render, staticRenderFns } from "./legal_detial_new.vue?vue&type=template&id=6a3dbc57&scoped=true"
import script from "./legal_detial_new.vue?vue&type=script&lang=js"
export * from "./legal_detial_new.vue?vue&type=script&lang=js"
import style0 from "./legal_detial_new.vue?vue&type=style&index=0&id=6a3dbc57&prod&scoped=true&lang=less"
import style1 from "./legal_detial_new.vue?vue&type=style&index=1&id=6a3dbc57&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3dbc57",
  null
  
)

export default component.exports